<script>
import Template from '{Template}/Admin/Pages/Admin/Reports/Wallets.template'
import AppLayout from '@/Layouts/AdminLayout'
import Welcome from '@/Jetstream/Welcome'
import NavButtonLink from "@/Jetstream/NavButtonLink";
import Pagination from '@/Jetstream/Pagination.vue';
import PaginationW from '@/Jetstream/PaginationW.vue';
import NavLink from "@/Jetstream/NavLink";
import Badge from "@/Jetstream/Badge";
import SearchFilter from '@/Jetstream/SearchFilter'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import {string_cut} from "@/Functions/String";
import AdminReportsTab from "@/Components/Reports/AdminReportsTab";
import axios from 'axios';

export default Template({

    components: {
        Badge,
        NavLink,
        NavButtonLink,
        AppLayout,
        Welcome,
        Pagination,
        SearchFilter,
        AdminReportsTab,
        PaginationW
    },
    props: {
        wallets: [],
	allWallets: [],
        filters: Object,
	links: [Array, Object],
	selectedCurrency: null,
        currencies: [],	
    },
    data() {
        return {
            sending: false,
            form: {
                search: (this.filters && this.filters.search) || '',
                type: (this.filters && this.filters.type) || 'all',
            },
            currentPage: 1,
            perPage: 100,
	    wallets: [],
	    allWallets: [],
        currencies: [],
	                
        }
    },

        created() {

    this.getCurrencies();
       
    },


    computed: {


	            filteredWallets() {
    if (!this.selectedCurrency || !Array.isArray(this.wallets.data)) {
        return []; // Return an empty array if no currency selected or wallets data is not an array
    }
    // Filter wallets based on selected currency
    return this.wallets.data.filter(wallet => wallet.currency && wallet.currency.symbol === this.selectedCurrency);
},




                groupedWallets() {
           if (this.wallets && Array.isArray(this.wallets.data) && this.wallets.data.length > 0) {
        
		

	    const grouped = {};

            this.wallets.data.forEach((wallet) => {
                const currencyId = wallet.currency_id;
                if (!grouped[currencyId]) {
                    grouped[currencyId] = [];
                }

                grouped[currencyId].push(wallet);
            });
	


            return grouped;
        } else {
            return {};
        }
    },

        paginatedGroupedWallets() {
    const groupedPaginatedWallets = [];
    let currentPage = 1;
    let remainingWallets = [];

    Object.values(this.groupedWallets).forEach((wallets) => {
        const startIndex = (currentPage - 1) * this.perPage;
        const endIndex = startIndex + this.perPage;

        if (remainingWallets.length > 0) {
            // If there are remaining wallets from the previous currency
            const remainingPerPage = this.perPage - remainingWallets.length;
            const slicedWallets = wallets.slice(0, remainingPerPage);
            remainingWallets.push(...slicedWallets);

            if (remainingWallets.length === this.perPage) {
                groupedPaginatedWallets.push(remainingWallets);
                remainingWallets = [];
                currentPage++;
            }

            wallets = wallets.slice(remainingPerPage);
        }

        while (wallets.length > 0) {
            groupedPaginatedWallets.push(wallets.slice(0, this.perPage));
            wallets = wallets.slice(this.perPage);
            currentPage++;
        }
    });

    // If there are remaining wallets after processing all currencies
    if (remainingWallets.length > 0) {
        groupedPaginatedWallets.push(remainingWallets);
    }

    return groupedPaginatedWallets;
},
},

    methods: {

    calculateSumByCurrency(currencySymbol) {
        let sum = 0;
        // Iterate through the wallets and sum the balances of wallets with the same currency
        this.allWallets.data.forEach(wallet => {
            if (wallet.currency && wallet.currency.symbol === currencySymbol) {
                sum += parseFloat(wallet.balance_in_wallet || 0);
                sum += parseFloat(wallet.balance_in_order || 0);
                sum += parseFloat(wallet.balance_in_withdraw || 0);
            }
        });
        return sum.toFixed(4);
    },


    selectCurrency(currency) {
      this.selectedCurrency = currency;
	

    },
    
    async getCurrencies() {
        try {
            if (this.allWallets && Array.isArray(this.allWallets.data) && this.allWallets.data.length > 0) {
                this.currencies = [...new Set(this.allWallets.data.map(wallet => wallet.currency.symbol))];
                
                if (this.currencies.length > 0) {
                    this.selectCurrency(this.currencies[0]);
                }
            }
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    },

        logWalletData() {
        
    },

        format_string(string, limit) {
            return string_cut(string, limit);
        },
        doCopy(string) {
            this.$copyText(string).then(() => {
                this.$toast.open('Text was copied to the clipboard');
            }, function (e) {

            })
        },
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        getList() {
            let query = pickBy(this.form, value => value !== null && value !== undefined);
            this.$inertia.replace(this.route('admin.reports.wallets', Object.keys(query).length ? query : { remember: 'forget' }))
        },


       
    goToPage(pageNumber) {
      // Update the route to navigate to the specified page
      this.$inertia.visit(`https://bitzipp.pro/exchange-control-panel/reports/wallets?page=${pageNumber}`);
    },


        calculateSum(wallet) {
            const sum =
                parseFloat(wallet.balance_in_wallet) +
                parseFloat(wallet.balance_in_order) +
                parseFloat(wallet.balance_in_withdraw);
            return sum.toFixed(4); // Adjust the number of decimal places as needed
        },

    },
    beforeRouteEnter(to, from, next) {
    next(vm => {
      // Call fetchWallets here since vm (this component) is available
      vm.fetchWallets();
    });
  },

    mounted() {
        
        this.logWalletData();
		
    },


   watch: {

        'wallets.data': {
            deep: true
    },

       form: {
           handler: throttle(function () {
                this.getList()
            }, 150),
            deep: true,
      },
        '$route.query.page': 'fetchWallets',
}

});
</script>
